module.exports = __webpack_public_path__ + "img/freight_yard5_21.fe04e49b.png";